//Polyfill pour firefox, ie, safari sur les sprites avec un zoom
(function ($) {
    $.fn.resizeContainerSprite = function () {
        return this.each(function () {
            
			var $this = $(this);
            var clientRect = this.getBoundingClientRect();

			$this.parent().css({
                'width': clientRect.width,
                'height': clientRect.height,
                'overflow': 'hidden'
			});
		});		
	}
}(jQuery));